import gql from 'graphql-tag';

export const updateMockExamStudent = gql`
  mutation updateMockExamStudent(
    $roundCode: String!
    $studentData: MockExamStudentProfileUpdateInput!
  ) {
    updateMockExamStudent(roundCode: $roundCode, studentData: $studentData) {
      success
      error
      studentProfile {
        ssid
        phone
        email
        roundCode
      }
    }
  }
`;
